var dsox = dsox || {};
dsox.Tabs = (function () {
    
//(function(){
    var tabWidget = function ($, mediaQueries) {
        var thisTabWidget = $('.js-tabs');
        thisTabWidget.each(function(){
            var thisTab = $(this);
            var allTabs = thisTab.find('.nav-item > a');

            var activeTab = thisTab.find('.nav-item > a.active');
            var circleIcon = thisTab.find('.js-circle-icon').find('[data-fa-i2svg]');

            if(mediaQueries.md.matches){
                circleIcon.removeClass('fa-plus').addClass('fa-chevron-down');
            } else {
                var activeTabIcon = activeTab.find('.js-circle-icon');
                activeTab.find('.js-circle-icon').find('[data-fa-i2svg]').removeClass('fa-plus').addClass('fa-minus');
            }

            var activeTabHeight = activeTab.outerHeight();
            var firstHeight = activeTabHeight + activeTab.siblings('.tab-pane').outerHeight()
            activeTab.parent().css({height: firstHeight});

            allTabs.on('click', function (e) {
                e.preventDefault();
                var thisTab = $(this);
                var thisSibling = thisTab.siblings('.tab-pane');
                
                if(mediaQueries.sm.matches){
                    allTabs.parent().css({height: activeTabHeight})
                    allTabs.removeClass('active');
                    allTabs.siblings('.tab-pane').removeClass('active');
                }else {
                    thisTab.find('.js-circle-icon').find('[data-fa-i2svg]').toggleClass('fa-plus').toggleClass('fa-minus');
                }
                
                
                thisTab.toggleClass('active');
                thisSibling.toggleClass('active');

                if(thisTab.hasClass('active')){
                    var newHeight = thisTab.outerHeight() + thisSibling.outerHeight();
                    thisTab.parent().css({height: newHeight});
                } else {
                    thisTab.parent().css({height: thisTab.outerHeight()});
                }
            });

            allTabs.css({'height': 'auto'});
            var maxHei = 0;
            allTabs.each(function (index) {
                var curHei = $(this).outerHeight();
                maxHei = (maxHei > curHei) ? maxHei : curHei;
                //console.log('tab.' + index + ': ', curHei, 'vs', maxHei);
            });
            //console.log('maxHei: ', maxHei);
            allTabs.css({'height': maxHei});
        });
    }

    return {
        tabWidget : tabWidget
    }
    //})();

}());